import { render, staticRenderFns } from "./MessagesContainer.vue?vue&type=template&id=7c60898a&scoped=true&"
import script from "./MessagesContainer.vue?vue&type=script&lang=js&"
export * from "./MessagesContainer.vue?vue&type=script&lang=js&"
import style0 from "./MessagesContainer.vue?vue&type=style&index=0&id=7c60898a&prod&scoped=true&lang=css&"
import style1 from "./MessagesContainer.vue?vue&type=style&index=1&id=7c60898a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60898a",
  null
  
)

export default component.exports